import { Pipe, PipeTransform } from '@angular/core';
import { AttachLabelPipe } from 'src/app/_shared/pipes/attach-label.pipe';

@Pipe({
    name: 'accountingVirtualWalletConsultationLabel',
    standalone: false
})
export class AccountingVirtualWalletAllocationLabelPipe implements PipeTransform {
    static format(virtualWallet: Record<string, any>, numberName = 'Numero', labelName = 'Libelle', closeName = 'IsClos'): string {
        if (!virtualWallet) {
            return '-';
        }

        return AttachLabelPipe.format(virtualWallet, numberName, labelName) + (virtualWallet?.[closeName] ? '(Clôturé)' : '');
    }

    transform(virtualWallet: Record<string, any>, numberName = 'Numero', labelName = 'Libelle', closeName = 'IsClos'): string {
        return AccountingVirtualWalletAllocationLabelPipe.format(virtualWallet, numberName, labelName, closeName);
    }
}
